import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ActionSection, ScrollableContent, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import { CircularProgress } from "@mui/material";
import Config from "../../Config";
import { addDays, getDueIcon, getDueLabel } from "../../helpers";
import { FiEdit2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

// const getDueLabel = (type) => {
//     switch (type) {
//         case Config.dueType.RENT:
//             return "Rent"
//         case Config.dueType.SECURITY:
//             return "Security"
//         case Config.dueType.MAINTENANCE:
//             return "Maintenance"
//         case Config.dueType.ELECTRICITY:
//             return "Electricity"
//         case Config.dueType.REGISTRATION:
//             return "Registration"
//         case Config.dueType.TECH_CHARGES:
//             return "Tech Charges"
//         case Config.dueType.OTHER:
//             return "Other"
//         case Config.dueType.AGREEMENT_CHARGE:
//             return "Agreement Charge"
//         case Config.dueType.FOOD:
//             return "Food"
//         case Config.dueType.FINE:
//             return "Fine"
//         case Config.dueType.SETTLEMENT:
//             return "Settlement"
//         case Config.dueType.WIFI:
//             return "Wifi Charges"
//         case Config.dueType.GAS:
//             return "Gas Charges"
//         case Config.dueType.MAID_CHARGES:
//             return "Maid CHarges"
//         case Config.dueType.DAMAGE:
//             return "Damage"
//         case Config.dueType.KEY_CHARGES:
//             return "Key Charges"
//         case Config.dueType.LAUNDRY_CHARGES:
//             return "Laundry Charges"
//         case Config.dueType.MOVE_OUT_CHARGES:
//             return "Moveout Charge"
//         default:
//             return "Unknown"
//     }
// }

const ViewFinalDues = ({
    setIsShowFinalDuesModal,
    apiData,
    dueListData,
    dueListLoading,
    editDueLoading,
    editDueMutate,
    tenantId,
    onSubmit,
    isGenerating,
    setIsAddDuesModal,
    setIsReturnDeposit,
    getListMutate
}) => {
    const [editingIndex, setEditingIndex] = useState(null)
    const [editedValue, setEditedValue] = useState("")
    const [dueEditId, setDueEditId] = useState(null)
    const due = dueListData?.data?.data?.pendingDues || []
    const securityAdjustedDues = dueListData?.data?.data?.securityAdjustedDues || []
    const dues = due.map((item) => ({
        label: getDueLabel(item.type),
        amount: item.balance,
        rentStartDate: item.rentStartDate,
        rentEndDate: item.rentEndDate,
        icon: getDueIcon(item.type),
        id: item.id,
    }))
    const securityAdjusted = securityAdjustedDues.map((item) => ({

        label: getDueLabel(item.type),
        amount: item.amount,
        rentStartDate: item.rentStartDate,
        rentEndDate: item.rentEndDate,
        icon: getDueIcon(item.type),
        id: item.id,
    }))
    const totalPendingDueAmount = dueListData?.data?.data?.totalPendingDueAmount
    const totalAdjustedDueAmount = dueListData?.data?.data?.totalAdjustedDueAmount
    const handleEditClick = (dueId, amount, index) => {
        if (editingIndex === index) {
            setEditingIndex(null)
        } else {
            setEditingIndex(index)
            setEditedValue(amount)
            setDueEditId(dueId)
        }
    }

    const handleEditSubmit = () => {
        if (editedValue > 1000000) {
            toast.error("Amount cannot be greater than 10,00,000");
            return;
        }
        editDueMutate({
            id: dueEditId,
            balance: parseInt(editedValue),
            isTemp: false,
            tenantId: tenantId,
            isEvicted: false,
        });
        setEditingIndex(null);

    };
    const onClose = () => {
        setIsShowFinalDuesModal(false);
        // getListMutate()
    };
    const totalDues = totalPendingDueAmount + Math.abs(totalAdjustedDueAmount)
    const handleSubmit = () => {
        if (onSubmit) {
            onSubmit();
        }
    };
    return (
        <Container>
            <Header>
                <Title>Final Summary</Title>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0 text-lg">
                        {apiData?.name}
                    </span>
                    <span className="text-sm text-gray-600">
                        {"#" + apiData?.occupancy?.roomNum || "N/A"},{" "}
                        {apiData?.occupancy?.flatName || "N/A"},{" "}
                        {apiData?.occupancy?.propName}
                    </span>
                </UserInfo>
                <div className="flex flex-col gap-0">
                    <span className="text-gray-500 text-sm">{"Security Paid"}</span>
                    <span className="text-xl font-semibold text-gray-700">
                        {'₹' + dueListData?.data?.data?.securityPaid}
                    </span>
                </div>
            </ProfileSection>
            {dueListLoading && (
                <div className="flex justify-center items-center my-40">
                    <CircularProgress size={40} />
                </div>
            )}
            <Content>
                <ScrollableContent>
                    <Wrapper>
                        {!dueListLoading && dueListData && (
                            <>
                                {/* Pending Dues Section */}
                                <SectionBox>
                                    <SectionHeader className="flex justify-between items-center">
                                        <SectionTitle>Pending Dues</SectionTitle>
                                        <button type="button" className="text-primary-color text-sm underline" onClick={() => setIsAddDuesModal(true)}>Add Dues</button>
                                    </SectionHeader>
                                    <SectionContent>
                                        {totalPendingDueAmount === 0 ? (
                                            <NoDataMessage>No Due Pending</NoDataMessage>
                                        ) : (
                                            <>
                                                {dues.map((due, index) => (
                                                    <DuesItem key={due.id}>
                                                        <DuesLabel>
                                                            {due.icon}
                                                            <span>{due.label === 'Rent' ?
                                                                due.label + ' : ' + moment(due?.rentStartDate || new Date()).format(
                                                                    'DD MMM YY',
                                                                ) +
                                                                ' - ' +
                                                                moment(
                                                                    due?.rentEndDate || addDays(new Date(), 30),
                                                                ).format('DD MMM YY')
                                                                :
                                                                due.label
                                                            }</span>
                                                            <EditIcon onClick={() => handleEditClick(due.id, due.amount, index)}>
                                                                <FiEdit2 size={12} />
                                                            </EditIcon>
                                                        </DuesLabel>
                                                        {editingIndex === index ? (
                                                            <div className="flex items-center space-x-2">
                                                                <input
                                                                    type="number"
                                                                    value={editedValue}
                                                                    onChange={(e) => setEditedValue(e.target.value)}
                                                                    className="ml-2 p-1 w-24 border rounded"
                                                                />

                                                                <button
                                                                    type="button"
                                                                    onClick={handleEditSubmit}
                                                                    className="bg-white text-primary-color border border-primary-color px-2 py-1.5 rounded text-xs"
                                                                    disabled={!editedValue || editDueLoading}
                                                                >
                                                                    {editDueLoading ? "Submitting..." : "Submit"}
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <Amount>₹{due.amount.toLocaleString()}</Amount>
                                                        )}
                                                    </DuesItem>
                                                ))}
                                                <TotalDues>
                                                    <span>Total Pending Dues</span>
                                                    <span>₹{totalPendingDueAmount}</span>
                                                </TotalDues>
                                            </>
                                        )}
                                    </SectionContent>
                                </SectionBox>

                                {/* Security Adjusted Dues Section */}
                                <SectionBox>
                                    <SectionHeader>
                                        <SectionTitle>Security Adjusted Dues</SectionTitle>
                                    </SectionHeader>
                                    <SectionContent>
                                        {totalAdjustedDueAmount === 0 ? (
                                            <NoDataMessage>No Adjusted Due</NoDataMessage>
                                        ) : (
                                            <>
                                                {securityAdjusted.map((due, index) => (

                                                    <DuesItem key={due.id}>
                                                        <DuesLabel>
                                                            {due.icon}
                                                            <span>{due.label === 'Rent' ?
                                                                due.label + ' : ' + moment(due?.rentStartDate || new Date()).format(
                                                                    'DD MMM YY',
                                                                ) +
                                                                ' - ' +
                                                                moment(
                                                                    due?.rentEndDate || addDays(new Date(), 30),
                                                                ).format('DD MMM YY')
                                                                :
                                                                due.label
                                                            }</span>
                                                        </DuesLabel>
                                                        <Amount>₹{Math.abs(due.amount)}</Amount>
                                                    </DuesItem>
                                                ))}
                                                <TotalDues>
                                                    <span>Total Adjusted Dues</span>
                                                    <span>₹{totalAdjustedDueAmount}</span>
                                                </TotalDues>
                                            </>
                                        )}
                                    </SectionContent>
                                </SectionBox>

                                {/* Summary Section */}
                                <SectionBox>
                                    <SectionHeader>
                                        <SectionTitle>Summary</SectionTitle>
                                    </SectionHeader>
                                    <SectionContent>
                                        <DuesItem>
                                            <DuesLabel>
                                                Security Paid
                                            </DuesLabel>
                                            <Amount>₹{dueListData?.data?.data?.securityPaid}</Amount>
                                        </DuesItem>
                                        <DuesItem>
                                            <DuesLabel>
                                                Dues
                                            </DuesLabel>
                                            <Amount>₹{Math.abs(totalDues)}</Amount>
                                        </DuesItem>
                                        <DuesItem>
                                            <DuesLabel>
                                                Refund
                                            </DuesLabel>
                                            <Amount>₹{dueListData?.data?.data?.totalRefund}</Amount>
                                        </DuesItem>
                                    </SectionContent>
                                </SectionBox>
                                {dueListData?.data?.data?.settlementSummaryDoc &&
                                    <Value className="text-primary-color underline">
                                        <Link
                                            to={dueListData?.data?.data?.settlementSummaryDoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {dueListData?.data?.data?.settlementSummaryDoc?.split("/").pop()}
                                        </Link>
                                    </Value>}
                            </>
                        )}
                    </Wrapper>
                </ScrollableContent>
                <ActionSection>
                    <SideCancelBtn type="submit"
                        onClick={handleSubmit}
                        disabled={isGenerating}>
                        {isGenerating ? "Loading..." : "Generate"}
                    </SideCancelBtn>
                    <SubmitBtn
                        type="button"
                        disabled={dueListData?.data?.data?.totalRefund < 1}
                        onClick={() => {
                            if (dueListData?.data?.data?.totalRefund < 1) return;
                            setIsReturnDeposit(true);
                        }}
                        className={
                            dueListData?.data?.data?.totalRefund < 1
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                        }
                    >
                        Refund
                    </SubmitBtn>

                </ActionSection>
            </Content>
        </Container>
    );
};

/* Styled Components */
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-4 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const DuesItem = tw.div`flex justify-between items-center py-2 border-b last:border-b-0`
const DuesLabel = tw.div`flex items-center space-x-2 text-sm text-gray-600`
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const EditIcon = tw.span`text-gray-400 cursor-pointer text-sm hover:text-gray-600`
const Amount = tw.div`text-gray-800 font-medium text-base`
const TotalDues = tw.div`flex justify-between items-center text-base font-medium text-gray-800 pt-2 pb-2 mt-2`
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const SectionBox = tw.div`border border-gray-200 rounded-lg overflow-hidden shadow-sm`;
const SectionHeader = tw.div`bg-gray-50 px-4 py-3 border-b`;
const SectionContent = tw.div`px-4 py-3`;
const NoDataMessage = tw.div`text-gray-500 text-center text-sm py-4`;
const Value = tw.span`text-gray-600 text-md`;
export default ViewFinalDues;